import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, keyframes } from 'styled-components';
const Wrapper = styled.div `
  display: flex;
`;
const loading = keyframes `
  0% {
    transform: scale(1);
  }
  20% {
    transform: scale(1, 1.8);
  }
  40% {
    transform: scale(1);
  }
`;
export const Bar = styled.div `
  display: inline-block;
  width: 4px;
  height: 18px;
  border-radius: 4px;
  margin: 0 2px;
  animation: ${loading} 1s ease-in-out infinite;
  &:nth-child(1) {
    background-color: ${({ $bgColor, theme }) => $bgColor ?? theme.colors.grey00_5};
    animation-delay: 0s;
  }
  &:nth-child(2) {
    background-color: ${({ $bgColor, theme }) => $bgColor ?? theme.colors.grey00_5};
    animation-delay: 0.09s;
  }
  &:nth-child(3) {
    background-color: ${({ $bgColor, theme }) => $bgColor ?? theme.colors.grey00_5};
    animation-delay: 0.18s;
  }
  &:nth-child(4) {
    background-color: ${({ $bgColor, theme }) => $bgColor ?? theme.colors.grey00_5};
    animation-delay: 0.27s;
  }
`;
const BarsLoader = ({ bgColor, ...other }) => (_jsxs(Wrapper, { ...other, children: [_jsx(Bar, { $bgColor: bgColor }), _jsx(Bar, { $bgColor: bgColor }), _jsx(Bar, { $bgColor: bgColor }), _jsx(Bar, { $bgColor: bgColor })] }));
export default BarsLoader;
